module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC4058-4cf861985ed99aace1248a2a692d3727.png";